export default "__VITE_ASSET__2bbc50bd__"